import { apiNames, get, post, put } from '@general/api/shared';

export const fetchCompanyByAccountID = (accountID, companyToken) => {
    const headers = {};

    if (companyToken) {
        headers['Icsc-Company-Agent-Api-Token'] = companyToken;
    }

    return get(apiNames.MEMBERSHIP, `companies/${accountID}?account_id=true`, headers);
};
export const fetchCompanyToken = accountID =>
    post({ apiName: apiNames.TRANSACTION, endpoint: `company-token`, data: { accountId: accountID } });

export const fetchCompanies = () => get(apiNames.MEMBERSHIP, `companies`);

export const searchCompanies = companyName => get(apiNames.MEMBERSHIP, `companies/search?${companyName}`);

export const addCompany = company => {
    const response = post({
        apiName: apiNames.MEMBERSHIP,
        endpoint: 'companies',
        data: company,
    });

    return response;
};

export const addCompanyMainAddress = (companyId, companyAddress) => {
    const response = put({
        apiName: apiNames.MEMBERSHIP,
        endpoint: `companies/${companyId}/addresses/main`,
        data: companyAddress,
    });

    return response;
};
